import { TypedQuery, TypedVariables } from "components/templates/dataGridTable/serverSide/types";
import { EntityMappings } from "graphqlBase/__utils__/entityMappings";
import { useOpenTaskFilterBuilder } from "pages/CertificateValidation/OpenTaskList/CustomOpenTaskFilters/utils/useOpenTaskFilterBuilder";
import { useCallback, useEffect, useState } from "react";
import { atom, useRecoilState } from "recoil";
// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved
import { merge } from "ts-deepmerge";
export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay ?? 100);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

export const unitDataGridQueryState = atom<TypedVariables<"Issue">>({
  key: "unitDataGridQueryState",
  default: {},
});

export function useCustomFilterbarForOpenTasks<E extends keyof EntityMappings>(
  query: TypedQuery<E>,
  customFilterValues?: object
) {
  const [variables, setVariables] = useState<TypedVariables<E>>();
  const [filterState, setFilterState] = useRecoilState<TypedVariables<"Issue">>(unitDataGridQueryState);
  const debouncedValue = useDebounce<TypedVariables<E> | undefined>(variables, 100);
  const { openTaskFilters } = useOpenTaskFilterBuilder();
  useEffect(() => {
    setVariables(merge(filterState, { where: { and: [openTaskFilters] } }) as TypedVariables<E>);
  }, [openTaskFilters, filterState, setVariables]);

  useEffect(() => {
    if (debouncedValue) {
      query({
        variables: debouncedValue,
      });
    }
  }, [query, debouncedValue]);

  const mockedQuery: TypedQuery<"Issue"> = useCallback(
    (options) => {
      setFilterState({
        where: options?.variables?.where,
        skip: options?.variables?.skip,
        order: options?.variables?.order,
        take: options?.variables?.take,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [query]
  );
  return mockedQuery;
}
